import Feature, { FeatureLike } from 'ol/Feature';
import MapBackgroundsEnum from '@/redux/map/map.enums';

const filledValues: boolean[][] = [];

const LAST_RESOLUTION_VALUE = -1;

let minResolution = -1;
let backgroundId: number = -1;

function getFeatureId(feature: FeatureLike): number | undefined {
  if (feature.getId() === undefined) {
    return undefined;
  }
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-expect-error
  return parseInt(feature.getId(), 10);
}

export function setFilledBackgroundId(value: number): void {
  backgroundId = value;
}

export function setMinResolution(value: number): void {
  minResolution = value;
}
export function isFeatureFilled(feature: FeatureLike | null, resolution: number): boolean {
  if (!feature) {
    return false;
  }
  if (resolution < minResolution) {
    return false;
  }
  if (backgroundId === MapBackgroundsEnum.NETWORK) {
    return false;
  }
  const id = getFeatureId(feature);
  if (!id) {
    // eslint-disable-next-line no-console
    console.log('Unknown feature id', feature);
    return false;
  }
  if (!filledValues[id]) {
    filledValues[id] = [];
  }
  let filled = filledValues[id][resolution];
  if (filled === undefined) {
    filled = filledValues[id][LAST_RESOLUTION_VALUE];
  }
  return filled;
}

export function setFeatureFilled(feature: Feature, resolution: number, value: boolean): void {
  const id = getFeatureId(feature);
  if (!id) {
    // eslint-disable-next-line no-console
    console.log('Unknown feature id', feature);
    return;
  }
  if (!filledValues[id]) {
    filledValues[id] = [];
  }

  // Cache per resolution: the main map and the magnifier loupe render the same
  // feature at different resolutions in the same frame, so a single shared slot
  // would let them clobber each other's value (causing the loupe to flicker
  // blank). Keying by resolution keeps each map's value independent. The
  // LAST_RESOLUTION_VALUE slot remains as a fallback for the first frame after a
  // resolution change, before that resolution has been cached.
  filledValues[id][resolution] = value;
  filledValues[id][LAST_RESOLUTION_VALUE] = value;
}
